// extracted by mini-css-extract-plugin
export var orderDetails = "_pc-2";
export var orderImage = "_pc-1";
export var orderMeta = "_pc-3";
export var orderSummary = "_pc-0";
export var rightArrow = "_pc-4";